export var helpCenterTypeToProduct = function helpCenterTypeToProduct(helpCenterType) {
  switch (helpCenterType) {
    case 'CUSTOMER_SERVICE':
      return 'CSM';
    case 'HELP_HUB':
      return 'JSM';
    default:
      return 'CSM';
  }
};